import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Tablenization from '@icoach/components/Tablenization';
import { CLUB_INBODY_ROUTER } from '@icoach/router/routerPath';
import { IN_BODY_INTERVIEW_TABS } from '@icoach/constants/';
import { Card, Typography, Button, Box } from "@curves/ui-base";
import { parseDate } from '@util/moment';
import { useInBodyContext } from '@icoach/inbody/components/InBodyContext';

const rowLabel = [
    {
        cellKey: 'measureDate',
        headerLabel: '量身時間',
        width: 20,
        formatCell: (value) => parseDate(value, 'YYYY-MM-DD HH:mm'),
    },
    {
        cellKey: 'employeeName',
        headerLabel: '量身擔當',
        width: 20,
    },
    {
        cellKey: 'interviewEmployeeName',
        headerLabel: '面談擔當',
        width: 20,
    },
    {
        cellKey: 'xFactorNotes',
        headerLabel: 'X-factor',
        width: 20,
        formatCell: (value = []) => {
            return value.map((target, index) => <Typography key={index}>{target}</Typography>);
        },
    },
    {
        cellKey: 'agreedNotes',
        headerLabel: '約定事項',
        formatCell: (value = []) => {
            return value.map((target, index) => <Typography key={index}>{target}</Typography>);
        },
    },
];

const InBodyHistoryTable = React.forwardRef((props, ref) => {
    const { sourceData, referenceID } = useInBodyContext();
    const history = useHistory();
    const [headerRow] = useState(() => {
        if (!Array.isArray(rowLabel) || rowLabel.length < 1) return [];
        return [...rowLabel];
    });

    const handleForwardOnClick = () => {
        history.push(CLUB_INBODY_ROUTER.GET_INTERVIEW_PATH(IN_BODY_INTERVIEW_TABS.SUMMARY, referenceID));
    };

    return (
        <Card>
            <Card.CardContent className="inbody-list">
                <Box component="header" className="page-header">
                    <Typography className="page-header-title" variant="h3">
                        歷史紀錄
                    </Typography>
                    <Box className="btn-group">
                        <Button name="create" variant="outlined" color="secondary" onClick={handleForwardOnClick}>
                            開始面談
                        </Button>
                    </Box>
                </Box>
                <Box>
                    <Tablenization cardProps={{ className: 'theme-gray' }}>
                        <Tablenization.TableRowHeader headerRow={headerRow} />
                        <Tablenization.TableRowBody headerRow={headerRow} rowsData={sourceData} />
                    </Tablenization>
                </Box>
            </Card.CardContent>
        </Card>
    );
});

export default InBodyHistoryTable;
